import {useLayoutEffect, useRef} from "react";

function useAtBottom(callback) {
    const ref = useRef(null);
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    useLayoutEffect(() => {
        function onScroll() {
            if (ref.current) {
                const rect = ref.current.getBoundingClientRect();
                const height = (window.innerHeight > document.documentElement.clientHeight ? window.innerHeight : document.documentElement.clientHeight) + 100;
                const atBottom = rect.top <= height;
                if (atBottom && typeof callbackRef.current === 'function') {
                    callbackRef.current();
                }
            }
        }
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [callbackRef]);
    return <div ref={ref}/>;
}

export default useAtBottom;
